'use client';

import { FaArrowLeft } from 'react-icons/fa';
import { useTheme } from '@mui/material';
import { useTranslation } from 'react-i18next';
import Link from 'next/link';
import { useComputedColor } from '@/hooks/useComputedColor';
import { Text } from '@/ui/Text';

export const SeeCampaigns = () => {
	const [trans] = useTranslation();
	const theme = useTheme();
	const color = useComputedColor(undefined, theme.palette.secondary.main);

	return (
		<Link href="/" style={{ textAlign: 'center' }}>
			<FaArrowLeft style={{ marginRight: '5px', marginTop: '7px', color }} />
			<Text
				sx={{
					'color': theme.palette.secondary.main,
					'fontSize': '16px',
					'&:hover': {
						cursor: 'pointer',
					},
					'& > p': {
						display: 'inline-block',
					},
				}}
				text={trans('seeCampaigns')}
				typographyComponent="span"
			/>
		</Link>
	);
};
